import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import { TotpEnrollment } from 'src/components/molecules/TotpEnrollment';
import { MfaCode } from './MfaCode';

type MfaTotpSetupProps = {
  setupUri: string | null;
  secret: string | null;
  onSubmit: (code: string) => Promise<void>;
  onCancel: () => void;
};

/**
 * Safety-net step: shown when Cognito forces authenticator app setup
 * during sign-in (e.g. a user whose email MFA is unavailable).
 */
export const MfaTotpSetup: FC<MfaTotpSetupProps> = ({
  setupUri,
  secret,
  onSubmit,
  onCancel,
}) => (
  <Box>
    <TotpEnrollment setupUri={setupUri} secret={secret} />
    <MfaCode
      description="Then enter the 6-digit code from the app to finish setup:"
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  </Box>
);
